const reverseDirection = value =>
    (value >= 0 ? parseInt(`-${value}`, 10) : Math.abs(value));


export default (valuesToSort, sortingRule) => {
    // Deep cloning the values to avoid affecting the state
    // of the original component
    const values = JSON.parse(JSON.stringify(valuesToSort));
    return values.sort(
      (a, b) => {
          if (a[sortingRule.column] > b[sortingRule.column]) {
              return sortingRule.direction;
          }
          if (a[sortingRule.column] < b[sortingRule.column]) {
              return reverseDirection(sortingRule.direction);
          }
          return 0;
      }
    );
};



/** WEBPACK FOOTER **
 ** ./src/utils/tableSortingTool.js
 **/